import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Enum } from './enum';
export var MaxWidthType = Enum({
  XS: 'xs',
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
  XL: 'xl',
  XXL: 'xxl'
});
export var MaxWidthValues = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, MaxWidthType.XS, 360), MaxWidthType.SM, 504), MaxWidthType.MD, 696), MaxWidthType.LG, 912), MaxWidthType.XL, 1152), MaxWidthType.XXL, 1440);
export function maxWidthClass(maxWidth) {
  if (!maxWidth) return '';
  return "max--".concat(maxWidth);
}